<template>

    <div class="news-card" :class="{ 'news-card--video': newsItem.video.url }" v-if="newsItem">
        <div class="news-card__photo news-card__photo--video" v-if="newsItem.video.url">
            <div class="video-wrapper">
                <iframe :src="newsItem.video.url"></iframe>
            </div>
        </div>
        <div class="news-card__photo news-card__photo--image" v-if="newsItem.photo.path">
            <img :src="newsItem.photo.path" :alt="newsItem.photo.alt">
        </div>

        <div class="news-card__details">
            <div class="news-card__tags" v-if="newsItem.tags"
                :class="{ 'has-ribbon': newsItem.ribbonColor.length, 'has-photo': newsItem.photo.path, 'has-video': newsItem.video.url }">
                <div class="ribbon" v-if="newsItem.ribbonColor"
                    :style="'background-color: ' + newsItem.ribbonColor + ';'"></div>
                <a href="#" :key="tag.id" v-for="(tag, index) in newsItem.tags">
                    <span>{{ tag.displayName }} <span class="pipe" v-if="index !== newsItem.tags.length - 1"> |
                        </span></span>
                </a>
            </div>

            <div class="news-card__date">{{ newsItem.date | moment("D - MMM") }}</div>

            <h3 class="news-card__title">{{ newsItem.title }}</h3>

            <div class="news-card__description">{{ newsItem.description }}</div>

            <a class="news-card__cta-primary cta-primary" :href="newsItem.link.url">
                @Sitecore.Globalization.Translate.Text("FultonCountyGa.NewsPromoGrid.Labels.ReadMore")
                <svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8"
                    xml:space="preserve" class="icon-arrow-right">
                    <path
                        d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z">
                    </path>
                </svg>
            </a>
        </div>
    </div>

</template>

<script>

export default {
    name: 'NewsItem',

    props: ['newsItem', 'layout'],
}

</script>